import { FileWrapper } from "kfplatform/filePicker";
import { useAccountStore } from "base/stores";

import { generateShortId } from "@account/common/helpers/index.js";
import { ServiceAccountService } from "@account/common/helpers/services/serviceaccount.service.js";
import { useAdminStore } from "../stores/admin.store.js";

export const updateServiceAccountProfile = (
  fileobj,
  serviceAccountId,
  profileUpdate
) => {
  let appIconConfig = {
    fileExtensions: ["JPG", "JPEG"],
    imageProps: {
      sizes: [
        [512, 512],
        [384, 384],
        [256, 256],
        [130, 130]
      ]
    },
    maxCount: 2,
    isProfile: true,
    validSelectedFile: [generateShortId("Attach")]
  };
  let uploadURL = `/user/2/${
    useAccountStore.getState()._id
  }/serviceaccount/${serviceAccountId}/avatar`;
  const fileUpload = new FileWrapper({
    file: fileobj,
    uploadURL: uploadURL,
    config: appIconConfig,
    prefix: serviceAccountId
  });
  fileUpload.onResponseDone((err, data) => {
    if (err) return;
    if (data && data.uploaded === 100) {
      profileUpdate(data, fileobj, serviceAccountId);
    }
  });
};

export const serviceAccountProfileUpdate = (image, file, serviceAccountId) => {
  if (image && image.photos) {
    let profilePhotots = image.photos;
    let ProfilePicture = {
      original: profilePhotots[0],
      preview: profilePhotots[1],
      large: profilePhotots[2],
      medium: profilePhotots[3],
      small: profilePhotots[4],
      fileId: file.fileId
    };
    const [promise] = ServiceAccountService.updateServiceAccountDetails(
      serviceAccountId,
      {
        ProfilePicture
      }
    );
    return promise;
  }
};

export function serviceBotBlob(url) {
  return ServiceAccountService.serviceBotProfileBlob(url);
}

export const imageFileObject = (fileBlob, fileId) => {
  const fileobj = new File([fileBlob], fileId + ".jpg", {
    type: "image/jpeg"
  });
  fileobj.fileId = fileId;
  return fileobj;
};

export const cancelApiRequest = (itemName, abortRequestList) => {
  let cancelReq = abortRequestList[itemName];
  cancelReq && cancelReq.cancel();
};

export function getApiBaseUrl(service = "accounts") {
  let url = useAdminStore.getState().apiBaseUrl;

  if (url) {
    return url.replace("<service_name>", service);
  }

  const accountId = useAccountStore.getState()._id;
  return `/${service}/2/${accountId}`;
}
